import { SettingsPaths } from "Pages/settings/paths";

export const USER_MANAGEMENT_SUB_PAGE_TITLES = {
    [SettingsPaths.userManagementNewUser]: "Create User",
    [SettingsPaths.userManagementTeam]: "Create Team",
    [SettingsPaths.userManagementSkillsNew]: "Create Skill",
    [SettingsPaths.userManagementSkillsEdit]: "Edit Skill",
    [SettingsPaths.userManagementCustomAttributesNew]: "Create Custom Attribute",
    [SettingsPaths.userManagementCustomAttributesEdit]: "Edit Custom Attribute",
} as const;

export const USER_MANAGEMENT_PAGE_DESCRIPTIONS = {
    [SettingsPaths.userManagementNewUser]: "User account creation and configuration.",
    [SettingsPaths.userManagementTeam]: "Team creation and configuration interface.",
    [SettingsPaths.userManagementSkillsNew]: "Skill definition and configuration.",
    [SettingsPaths.userManagementSkillsEdit]: "Skill definition and configuration.",
    [SettingsPaths.userManagementCustomAttributesNew]:
        "Create and manage custom user attributes. Max 10 attributes allowed.",
    [SettingsPaths.userManagementCustomAttributesEdit]:
        "Create and manage custom user attributes. Max 10 attributes allowed.",
} as const;

// Header/title copy overrides used by page headers for routes that need
// temporary UI text parity during metadata migration.
export const USER_MANAGEMENT_PAGE_TITLE_PATCH = {
    [SettingsPaths.userManagementCustomAttributesNew]: "Create New Attribute",
} as const;

// Description copy overrides used by page subtitle/description surfaces.
// Keep these separate from title patches so header text and body copy can
// be updated independently.
export const USER_MANAGEMENT_PAGE_DESCRIPTION_PATCH = {
    [SettingsPaths.userManagementNewUser]: "Create and manage user accounts.",
    [SettingsPaths.userManagementTeam]: "Create and manage teams.",
    [SettingsPaths.userManagementSkillsNew]: "Create and manage skills.",
    [SettingsPaths.userManagementSkillsEdit]: "Create and manage skills.",
    [SettingsPaths.userManagementCustomAttributesNew]:
        "Create and manage custom user attributes. Max 10 attributes allowed.",
    [SettingsPaths.userManagementCustomAttributesEdit]:
        "Create and manage custom user attributes. Max 10 attributes allowed.",
} as const;
